<template>
  <div class = "modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Renombrar la pestaña</p>
    </header>

    <section class="modal-card-body">
      <div class="forms-container">
        <b-field label="Nombre de la pestaña">
          <b-input type="text" v-model="filename" id="nameField" placeholder="por ejemplo: acciones"  ref="nameField" required> </b-input>
        </b-field>
      </div>
    </section>

    <footer class="modal-card-foot">
      <a class="btn" v-on:click="$parent.close()">Cancelar</a>
      <a class="btn btn-bg-colored" v-on:click="renameFile">Renombrar pestaña</a>
    </footer>
  </div>
</template>
<script>
export default {
  name: 'NewClassRoom',
  data: () => ({
    filename: null
  }),
  computed: {
    project () {
      return this.$store.state.project
    },
    editorConfig () {
      return this.$store.state.editorConfig
    }
  },
  methods: {
    renameFile () {
      this.$store.commit('renameCodeFile', this.filename)
      this.$store.dispatch('saveProject')
      this.$parent.close()
    }
  },
  created () {
  }
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Editor/EditorRenameFile.vue